import { render, staticRenderFns } from "./fIndex.vue?vue&type=template&id=9fae1830&scoped=true&"
import script from "./fIndex.vue?vue&type=script&lang=js&"
export * from "./fIndex.vue?vue&type=script&lang=js&"
import style0 from "./fIndex.vue?vue&type=style&index=0&lang=less&"
import style1 from "./fIndex.vue?vue&type=style&index=1&id=9fae1830&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fae1830",
  null
  
)

export default component.exports